export default __webpack_public_path__ + "static/media/greenTruckTablet.207c5589.jpg";